const Button = ({ title, type = 'button', onClick = () => { }, className, disabled= false }) => {
    // CHANGE: Removed 'w-32' and added 'w-auto px-6' to let it grow with content
    const defaultClass = 'py-2 px-6 w-auto min-w-[8rem] bg-primary hover:bg-primary/90 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md cursor-pointer select-none flex justify-center items-center';
    
    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`${defaultClass} ${className}`}
        >
            {title}
        </button>
    )
}

export default Button;